// src/services/requestTracker.js
//
// Tiny pub-sub counter for in-flight axios requests. The apiClient
// increments on request and decrements on response (or error). A top-
// of-page progress bar subscribes and renders a thin bar whenever the
// counter > 0.
//
// Separate from the offline queue so consumers can listen to either
// concern independently.

const listeners = new Set();
let count = 0;

export const requestTracker = {
  subscribe(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
  getSnapshot() {
    return count;
  },
  start() {
    count += 1;
    listeners.forEach((fn) => fn(count));
  },
  end() {
    count = Math.max(0, count - 1);
    listeners.forEach((fn) => fn(count));
  },
  reset() {
    count = 0;
    listeners.forEach((fn) => fn(count));
  },
};

export default requestTracker;
